var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEth(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 45,
    height: 45,
    viewBox: "0 0 45 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_365_4605)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.5 45C34.9264 45 45 34.9264 45 22.5C45 10.0736 34.9264 0 22.5 0C10.0736 0 0 10.0736 0 22.5C0 34.9264 10.0736 45 22.5 45Z",
    fill: "#627EEA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.5 5.625V18.0984L33.0427 22.8094L22.5 5.625Z",
    fill: "white",
    fillOpacity: 0.602
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.2003 5.625L12.6562 22.8094L23.2003 18.0984V5.625Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.5 31.4325V39.908L33.0497 25.3125L22.5 31.4325Z",
    fill: "white",
    fillOpacity: 0.602
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.2003 39.908V31.4311L12.6562 25.3125L23.2003 39.908Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.5 29.1108L33.0427 22.9894L22.5 18.2812V29.1108Z",
    fill: "white",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.6562 22.9894L23.2003 29.1108V18.2812L12.6562 22.9894Z",
    fill: "white",
    fillOpacity: 0.602
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_365_4605"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 45,
    height: 45,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEth);
export default __webpack_public_path__ + "static/media/eth.f047e508d7f20f217f12e81c654ba1a7.svg";
export { ForwardRef as ReactComponent };